/**
 * The institution's short name: `organizations.terminology.short_name`
 * (ALU-155, Juan 26/09).
 *
 * "Universidad Nacional de Ciencias Económicas del Litoral" does not fit the
 * top of the sidebar or the phone bar without wrapping. An admin can give a
 * short one in Ajustes › Terminología ("Económicas UNL"), and the Encuentro
 * switcher shows it there. The full name stays everywhere else: the switcher's
 * tooltip and label, the communities menu and every page heading. Unset keeps
 * the full name, in up to two lines.
 *
 * No zod here: this module reaches client bundles. The save validation lives
 * in the server action (`updateOrgTerminology`).
 */

/** Longest short name: one line of the switcher at 16 px, about. */
export const SHORT_NAME_MAX = 24

/** The short name from the `terminology` JSON, trimmed; null when unset or empty. */
export function readShortName(terminology?: unknown): string | null {
  if (!terminology || typeof terminology !== 'object' || Array.isArray(terminology)) return null
  const raw = (terminology as Record<string, unknown>).short_name
  const value = typeof raw === 'string' ? raw.trim() : ''
  return value ? value.slice(0, SHORT_NAME_MAX) : null
}
